
import type { Product } from './types';

export const supermaxProducts: Product[] = [
  {
    id: 'sm1',
    shopId: '11',
    name: 'SuperMax Oilgermany Hydraulic System Oil 68',
    brand: 'SuperMax',
    price: 150, // UPDATED
    image: 'http://www.oilgermany.com/Upload/Urunler/Buyuk/352018-16lt-hidroliksistem68-133859.jpg', // updated
    description: 'Hydraulic oil for high-performance hydraulic systems.',
    category: 'oil',
  },
  {
    id: 'sm2',
    shopId: '11',
    name: 'SuperMax Oilgermany Premium 15W/40',
    brand: 'SuperMax',
    price: 100, // UPDATED
    image: 'http://www.oilgermany.com/Upload/Urunler/Buyuk/3042018-4lt-siyahsari-172218.jpg', // updated
    description: 'Premium 15W/40 engine oil for heavy-duty vehicles.',
    category: 'oil',
  },
];
